import { asLocale, intlLocale } from '@saniplus/api-client';
import type { Locale } from '@saniplus/contracts';
import { useTranslation } from 'react-i18next';

/**
 * The UI locale as the frozen `Locale` enum, plus its `Intl` tag.
 *
 * The narrowing is `asLocale`, never a hand-rolled `=== 'en' ? 'en' : 'fr'`:
 * five spellings of that comparison agreed only because `supportedLngs` is
 * two long today.
 *
 * `useLocale` from `@saniplus/api-client` also *writes* the choice (IndexedDB,
 * `POST /me/locale`); these screens only read it, and asking a read for the
 * database name it will never open is noise. Same source of truth either way:
 * `i18n.language`.
 */
export function useUiLocale(): { locale: Locale; intl: string } {
  const { i18n } = useTranslation();
  const locale = asLocale(i18n.language) ?? 'fr';
  return { locale, intl: intlLocale(locale) };
}
